export const initQuery = async () => {
    const res = await fetch('https://manage-api.realbaka.net/mrchildren');
    const json = await res.json();
    return json;
};
export const initConfig = {
    cacheTime:1000 * 5,
    staleTime:1000 * 60,
};
